import React from 'react'
import './StepSpacingWrapper.scss'

export function StepSpacingWrapper({ children, noPadding }) {
  return (
    <div className={`step-spacing-wrapper ${noPadding ? 'no-padding' : ''}`}>
      {children}
    </div>
  )
}
